import React from "react";
import { profile } from "../data/profile";

const links = [
  { label: "Github", href: profile.github, external: true },
  { label: "LinkedIn", href: profile.linkedin, external: true },
  { label: "Resume", href: profile.cvFile, download: true },
];

function OverviewLinks() {
  return (
    <div className="overview-links">
      {links.map((l, i) => (
        <a
          key={l.label}
          className="overview-links-item"
          href={l.href}
          {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          {...(l.download ? { download: true } : {})}
        >
          <div>{String(i + 1).padStart(2, "0")}</div>
          <div>{l.label}</div>
          <div aria-hidden="true">↗</div>
        </a>
      ))}
    </div>
  );
}

export default OverviewLinks;
